import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StatusPopupProps } from '@popups/StatusPopup/types';
import { BasicEntity } from '@/types/common';
import { useStore } from './useStore';

/**
 * Custom hook to handle entity click actions.
 * It opens a popup for declined entities or navigates to the entity's detail page.
 */
export const useOnEntityClick = <T extends BasicEntity>() => {
  const {
    popupStore: { openPopup },
  } = useStore();

  const [popupData, setPopupData] = useState<StatusPopupProps | null>(null);

  const navigate = useNavigate();

  const onClick = useCallback(({ id, status, adminMessage }: T) => {
    if (status === 'Declined') {
      if (adminMessage) {
        setPopupData({ status, text: adminMessage });
        openPopup('status');
      }
      return;
    }
    if (status === 'Pending') {
      setPopupData({ status, text: adminMessage });
      openPopup('status');
      return;
    }
    navigate(`${id}?status=${status}`);
  }, []);
  return { onClick, popupData };
};
